import archidekt from '@/assets/ads/archidekt.webp'
import ckBuylist from '@/assets/ads/ckBuylist.webp'
import crossword from '@/assets/ads/crossword.webp'
import cs from '@/assets/ads/cs.webp'
import csb from '@/assets/ads/csb.webp'
import csHobbit from '@/assets/ads/csHobbit.webp'
import edhrecap from '@/assets/ads/edhrecap.webp'
import edhrecPatreon from '@/assets/ads/edhrecPatreon.webp'
import edhrecPatreon201 from '@/assets/ads/edhrecPatreon201.webp'
import edhrecPatreon202 from '@/assets/ads/edhrecPatreon202.webp'
import edhrecPatreon203 from '@/assets/ads/edhrecPatreon203.webp'
import spellifyDark1 from '@/assets/ads/spellifyDark1.webp'
import spellifyDark2 from '@/assets/ads/spellifyDark2.webp'
import spellifyLight1 from '@/assets/ads/spellifyLight1.webp'
import spellifyLight2 from '@/assets/ads/spellifyLight2.webp'
import tcgplayerIntl from '@/assets/ads/tcgplayerIntl.webp'
import tcgplayerMayhem from '@/assets/ads/tcgplayerMayhem.webp'

export const AD_GLOBAL_STATUS = {
  ADHESION_DESKTOP: true,
  ADHESION_MOBILE: true,
  ADHESION_TABLET: true,
  GALLERY_INCONTENT: true,
  LEADERBOARD: true,
  MID_BANNER: false,
  SIDEBAR: true,
  UVPPLUS: false,
}

export type AdUnitType = 'leaderboard' | 'midbanner'

export type GalleryIncontentGapType = {
  rowsBetween: number
  rowsFirst: number
}

export const GALLERY_INCONTENT_GAPS: Record<number, GalleryIncontentGapType> = {
  1: { rowsBetween: 10, rowsFirst: 5 },
  2: { rowsBetween: 5, rowsFirst: 2 },
  3: { rowsBetween: 3, rowsFirst: 1 },
  4: { rowsBetween: 2, rowsFirst: 1 },
}

export const MEDIAVINE_IDENTITY_EVENT = 'mediavineIdentityReady'
export const ADHESION_EVENT = 'adhesionchange'
export const ADHESION_DESKTOP_CSS_VAR = '--adhesion-desktop-height'
export const ADHESION_DESKTOP_WRAPPER_ID = 'adhesion_desktop_wrapper'
export const ADHESION_MOBILE_CSS_VAR = '--adhesion-mobile-height'
export const ADHESION_MOBILE_WRAPPER_ID = 'adhesion_mobile_wrapper'

export const MEDIAVINE_INLINE_CSS_CLASS = 'ArticlePage_content'
export const MEDIAVINE_INCONTENT_CSS_CLASS = 'mv_slot_target'

export type AdConfigType = {
  alt: string
  src: string
  url: string
}

export const AD_CONFIG_ENTRIES = {
  archidekt: { alt: 'Archidekt', src: archidekt.src, url: 'https://archidekt.com/landing' },
  ckBuylist: {
    alt: 'Get 30% Credit When Selling To Card Kingdom',
    src: ckBuylist.src,
    url: 'https://www.cardkingdom.com/purchasing/how_to_sell?partner=EDHRECSell&utm_medium=affiliate&utm_campaign=edhrec&partner_args=leaderboard',
  },
  crossword: { alt: 'EDHREC Crossword', src: crossword.src, url: 'https://edhrec.com/games/crossword' },
  cs: { alt: 'Cardsphere', src: cs.src, url: 'https://cardsphere.com' },
  csb: { alt: 'Commander Spellbook', src: csb.src, url: 'https://commanderspellbook.com' },
  csHobbit: { alt: 'Cardsphere', src: csHobbit.src, url: 'https://try.cardsphere.com/edhrec-hobbit' },
  edhrecap: { alt: 'EDHRecap', src: edhrecap.src, url: 'https://edhrec.com/newsletter' },
  edhrecPatreon: { alt: 'EDHREC Patreon', src: edhrecPatreon.src, url: 'https://patreon.com/edhrec' },
  edhrecPatreon201: { alt: 'EDHREC Patreon', src: edhrecPatreon201.src, url: 'https://patreon.com/edhrec' },
  edhrecPatreon202: { alt: 'EDHREC Patreon', src: edhrecPatreon202.src, url: 'https://patreon.com/edhrec' },
  edhrecPatreon203: { alt: 'EDHREC Patreon', src: edhrecPatreon203.src, url: 'https://patreon.com/edhrec' },
  spellifyDark1: {
    alt: 'Spellify',
    src: spellifyDark1.src,
    url: 'https://edhrec.com/games/spellify?utm_campaign=dark1',
  },
  spellifyDark2: {
    alt: 'Spellify',
    src: spellifyDark2.src,
    url: 'https://edhrec.com/games/spellify?utm_campaign=dark2',
  },
  spellifyLight1: {
    alt: 'Spellify',
    src: spellifyLight1.src,
    url: 'https://edhrec.com/games/spellify?utm_campaign=light1',
  },
  spellifyLight2: {
    alt: 'Spellify',
    src: spellifyLight2.src,
    url: 'https://edhrec.com/games/spellify?utm_campaign=light2',
  },
  tcgplayerIntl: {
    alt: 'TCGPlayer International Shipping',
    src: tcgplayerIntl.src,
    url: 'https://partner.tcgplayer.com/c/4913290/3841229/21018',
  },
  tcgplayerMayhem: {
    alt: 'TCGPlayer Mayhem',
    src: tcgplayerMayhem.src,
    url: 'https://partner.tcgplayer.com/c/4913290/3904321/21018',
  },
}

export type AdIdType = keyof typeof AD_CONFIG_ENTRIES
export const AD_CONFIG: Record<AdIdType, AdConfigType> = AD_CONFIG_ENTRIES
